import {
	IconPersonChecked,
	IconPersons,
} from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from 'components/common/Menu';

const menuConfig: TMenuItem[] = [
	{
		type: 'Clickable',
		text: 'Accounts',
		link: '/syspower/users',
		icon: <IconPersons />,
	},
	{
		type: 'Clickable',
		text: 'Subscriptions',
		link: '/syspower/subscriptions',
		icon: <IconPersonChecked />,
	},
];

export default menuConfig;
